import { Component, Input } from '@angular/core';

@Component({
    selector: 'ham-tiptap-icon',
    templateUrl: 'ham-tiptap-icon.component.html',
    styleUrls: ['ham-tiptap-icon.component.scss'],
})
export class HamTiptapIconComponent {
    @Input() icon: string = '';
    @Input() size: number | string = 16;
    @Input() strokeWidth = 1.8;
}
